import React, { useState, useEffect, useRef } from 'react';
import {
  IconButton,
  Popover,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

function EmployeeFilterMenu({ onFilterChange, t }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isShowWarnings, setShowWarnings] = useState(true);
  const [isExcludeNotTransferred, setExcludeNotTransferred] = useState(true);
  const iconButtonRef = useRef(null);
  const isFirstRender = useRef(true);

useEffect(() => {
  if (isFirstRender.current) {
    isFirstRender.current = false;
    return;
  }

  if (onFilterChange) {
    onFilterChange({ isShowWarnings, isExcludeNotTransferred });
  }
}, [isShowWarnings, isExcludeNotTransferred]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  return (
    <div style={{ display: 'inline-block', position: 'relative' }}>
      <IconButton ref={iconButtonRef} onClick={handleOpen} size="large">
        <FilterListIcon />
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          style: {
            overflow: 'visible',
            position: 'relative',
            width: 280,
          }
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: -8,
            right: 15,
            width: 0,
            height: 0,
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            borderBottom: '8px solid white',
          }}
        />
        <div style={{ padding: 10 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isShowWarnings}
                onChange={(e) => setShowWarnings(e.target.checked)}
              />
            }
            label={t("employeeSidePanel.privateEmployeeFilters.warnings")}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isExcludeNotTransferred}
                onChange={(e) => setExcludeNotTransferred(e.target.checked)}
              />
            }
            label={t("employeeSidePanel.privateEmployeeFilters.excludeTransferredIn")}
          />
        </div>
      </Popover>
    </div>
  );
}
export default EmployeeFilterMenu;